/* src/app/modules/resume/balance/balance.component.css */
.bd-header {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 24px 24px 0;
  position: relative;
}
.bd-header__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(227, 253, 100, 0.12);
  flex-shrink: 0;
}
.bd-header__icon-wrap mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: #e3fd64;
}
.bd-header__title {
  margin: 0 !important;
  padding: 0 !important;
  font-size: 17px !important;
  font-weight: 600 !important;
  line-height: 1.3 !important;
}
.bd-header__sub {
  margin: 3px 0 0;
  font-size: 13px;
  color: #6b7280;
}
.bd-close {
  position: absolute !important;
  top: 16px;
  right: 16px;
  color: #9ca3af !important;
}
.bd-content {
  padding: 20px 24px 8px !important;
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 380px;
  overflow: visible !important;
}
.bd-toggle {
  display: flex;
  align-items: center;
}
.bd-dates {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}
.bd-field {
  flex: 1;
  min-width: 150px;
}
.bd-actions {
  padding: 8px 24px 20px !important;
  justify-content: flex-end !important;
  gap: 8px;
}
.bd-btn-export {
  background-color: #e3fd64 !important;
  color: #1a1d23 !important;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.bd-btn-export mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.bd-btn-export:disabled {
  background-color: #e5e7eb !important;
  color: #9ca3af !important;
}
.bd-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  padding: 52px 40px;
}
.bd-loading__dots {
  display: flex;
  gap: 8px;
}
.bd-loading__dots span {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #e3fd64;
  opacity: 0.3;
  animation: bd-pulse 1.2s ease-in-out infinite;
}
.bd-loading__dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.bd-loading__dots span:nth-child(3) {
  animation-delay: 0.4s;
}
.bd-loading__text {
  margin: 0;
  font-size: 14px;
  color: #6b7280;
}
@keyframes bd-pulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.9);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
/*# sourceMappingURL=balance.component.css.map */
